/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils

/* ++++++++++ --------------- EXPORT : SET THEME CONFIRM : STYLES --------------- ++++++++++ */
export default theme =>({
  '@global': {
    '.modalpage': { 
      borderRadius: pxToEm(12),
      '& .close': {
        border: 'none',
        '& .icon': {
          color: '#061240'
        }
      }
    }
  },
  setthemeconfirm: {
    extend: theme.modal.form,
    maxWidth: pxToEm(420),
    padding: `${pxToEm(8)} ${pxToEm(16)}`,
    '& .name-setthemeconfirm':{
      '& .bodycopy':{
        marginTop:pxToEm(32),
        marginBottom: pxToEm(24),
        textAlign: 'left'
      }
    },
    '& .name-ctas':{
      marginTop:pxToEm(16),
      flexWrap: 'nowrap',
      '& .button': {
        width: '100%'
      },
      '& .name-confirm': {
        background: '#5A74DD',
        '&:hover': {
          background: '#0C2483'
        }
      }
    },
    '& .header': {
      borderBottom: '3px solid #000',
      paddingBottom: pxToEm(8),
      textAlign: 'center'
    }
  }
});
